const ClockIcon = () => (
  <div>
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8333 7.0013C12.8333 10.2213 10.22 12.8346 6.99999 12.8346C3.77999 12.8346 1.16666 10.2213 1.16666 7.0013C1.16666 3.7813 3.77999 1.16797 6.99999 1.16797C10.22 1.16797 12.8333 3.7813 12.8333 7.0013Z"
        stroke="#9E9E9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16418 8.85307L7.35585 7.77391C7.04085 7.58724 6.78418 7.13807 6.78418 6.77057V4.37891"
        stroke="#9E9E9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default ClockIcon;
